"use client";
import { useState, useEffect } from "react";

import { useSelector, useDispatch } from "react-redux";

import { setCity, setDistricts, setTowns } from "@/src/store/filter";

import { getCities } from "services/location";

import CityDropdowns from "./dropdown";

import styles from "@/src/components/listing-search/filter-items/styles.module.css";

const CityDropdown = () => {
  const [cities, setCities] = useState([]);
  const [filteredCities, setFilteredCities] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [isListboxOpen, setIsListboxOpen] = useState(false);

  const locationCity = useSelector((state) => state.filter.city);

  const dispatch = useDispatch();

  const prepareCities = async () => {
    try {
      const arr = [];
      const res = await getCities();
      await res?.result?.map((item) => arr.push({ ...item, key: item.id, value: item.name }));
      setCities(arr);
    } catch (error) {
      console.error("Error from prepareCities: ", error);
    }
  };

  const handleCityChange = (event) => {
    const cityObject = {
      id: event.id,
      slug: event.slug,
      name: event.name,
    };
    dispatch(setDistricts([]));
    dispatch(setTowns([]));
    dispatch(setCity(cityObject));
    setInputValue("");
    setFilteredCities([]);
  };

  const handleInputChange = (p) => {
    setInputValue(p);
    setFilteredCities(
      p.length ? cities.filter((x) => x.name.toLocaleLowerCase("tr-TR").indexOf(p.toLocaleLowerCase("tr-TR")) >= 0) : []
    );
  };

  const handleListBoxOpenState = (isOpen) => {
    setIsListboxOpen(isOpen);
  };

  useEffect(() => {
    prepareCities();
  }, []);

  useEffect(() => {
    if (!isListboxOpen) {
      setInputValue("");
    }
  }, [isListboxOpen]);

  useEffect(() => {
    if (isListboxOpen === false) {
      setFilteredCities([]);
    }
  }, [isListboxOpen]);

  return (
    <div className={styles.dropdownWrapper}>
      <CityDropdowns
        options={filteredCities.length ? filteredCities : cities}
        placeholder="İl"
        onChange={handleCityChange}
        selected={locationCity || null}
        listClass={styles.districtsClass}
        inputValue={inputValue}
        handleInputChange={(e) => handleInputChange(e.target.value)}
        onOpenChange={handleListBoxOpenState}
      />
    </div>
  );
};

export default CityDropdown;
